import { getSalesId } from './general';
import { getCart } from './cart';

import request from 'src/utils/request';
import { CONNECT, CONNECT_CLIENT } from 'src/utils/environment';
import { getSession } from 'src/utils/localStorage';
import QueryStringRetriever from 'src/utils/queryStringRetriever';

export const INSURANCE_CONFIG_IDS_BY_CONNECT_CLIENT = {
  skibig3: 7,
  "lutsen-mountains": 13,
  "stein-lodge": 134,
  "stein-residences": 136,
  "the-chateaux-deer-valley": 135
};

export const getInsuranceConfigId = (client = CONNECT_CLIENT) => INSURANCE_CONFIG_IDS_BY_CONNECT_CLIENT[client] || client;

/**
 * Check, add, or remove Inntopia travel insurance for the current itinerary.
 * This is the Connect endpoint used by ReactBooking's review flow.
 */
export async function updateItineraryInsurance(action = 0) {
  const salesId = getSalesId();
  const session = getSession();

  if (!session?.uuid) {
    throw new Error('Missing Inntopia session');
  }

  const response = await request({
    url: `${CONNECT}/cart/insurance`,
    method: 'POST',
    data: {
      id: getInsuranceConfigId(),
      salesId,
      sessionId: session.uuid,
      add: action
    }
  });

  // The Connect response is the insurance offer. Re-fetch the cart after
  // mutations so Summary reads the backend's authoritative line items/totals.
  if (action === 1 || action === -1) {
    await getCart();
  }

  return response.data;
}

export function getItinerary () {
  return new Promise((resolve, reject) => {
    const inntopiaSalesId = getSalesId();
    const session = getSession();

    request({
      url: `${CONNECT}/inntopia/cart/itinerary`,
      method: 'POST',
      data: {
        id: inntopiaSalesId,
        salesId: inntopiaSalesId,
        sessionId: session?.uuid,
      }
    })
    .then((response) => {
      const data = response.data || null;

      if (data.items) {
        resolve(data);
      }

      reject(null);
    })
    .catch(err => {
      console.log('error service/getItinerary', err);
      reject(err)
    });
  })
};

export function updateItineraryRequirements (itineraryRequirements) {
  return new Promise((resolve, reject) => {
    const inntopiaSalesId = getSalesId();
    const session = getSession();

    request({
      url: `${CONNECT}/inntopia/checkout/customer-requirements-itinerary`,
      method: 'POST',
      data: {
        id: inntopiaSalesId,
        salesId: inntopiaSalesId,
        sessionId: session?.uuid,
        itineraryRequirements
      }
    })
    .then((response) => {
      const data = response.data || null;

      if (data.ok) {
        resolve(true);
      }

      reject(false);
    })
    .catch(err => {
      console.log('error service/updateItineraryRequirements', err);
      reject(err)
    });
  })
};

export function getItineraryPolicies () {
  return new Promise((resolve, reject) => {
    const inntopiaSalesId = getSalesId();
    const session = getSession();

    request({
      url: `${CONNECT}/inntopia/cart/policies`,
      method: 'POST',
      data: {
        id: inntopiaSalesId,
        salesId: inntopiaSalesId,
        sessionId: session?.uuid,
        language: 'en-us'
      }
    })
    .then((response) => {
      const data = response.data || null;

      resolve(data);
    })
    .catch(err => {
      console.log('error service/getItineraryPolicies', err);
      reject(err)
    });
  })
};

export function affirmCheckout () {
  return new Promise((resolve, reject) => {
    const inntopiaSalesId = getSalesId();
    const session = getSession();

    request({
      url: `${CONNECT}/inntopia/affirm/checkouttoken`,
      method: 'POST',
      data: {
          sessionId: session?.uuid,
          salesId: inntopiaSalesId,
          checkoutToken: QueryStringRetriever().checkout_token
      }
    })
    .then((response) => {
      resolve(response);
    })
    .catch(err => {
      console.log('error service/affirmCheckout', err);
      reject(err)
    });
  })
};

export function confirmItinerary (paymentMethod) {
  return new Promise((resolve, reject) => {
    const inntopiaSalesId = getSalesId();
    const session = getSession();

    request({
      url: `${CONNECT}/inntopia/checkout/confirm`,
      method: 'POST',
      data: {
          sessionId: session?.uuid,
          salesId: inntopiaSalesId,
          paymentMethod
      }
    })
    .then(response => {
      resolve(response);
    })
    .catch(err => {
      reject(err)
    });
  })
};
